// philippinesV2Language.ts
// ─── Astria Philippines v2 — self-contained EN/PH language toggle ─────────
// Scoped entirely to this feature — does NOT touch the app-wide i18next
// setup (src/i18n.ts) or any other country lane. Persists only the
// Philippines V2 screen's own language choice, independent of the
// account's global `preferredLanguage`. Same pattern as
// vietnamV2Language.ts.
import { useCallback, useEffect, useState } from "react";

export type PhilippinesV2Lang = "en" | "ph";

const STORAGE_KEY = "astriaPhilippinesV2Lang";

export function getStoredPhilippinesV2Lang(): PhilippinesV2Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "ph") return stored;
  } catch {
    // localStorage unavailable — fall through to default
  }
  return "ph";
}

export function usePhilippinesV2Language(): [
  PhilippinesV2Lang,
  (lang: PhilippinesV2Lang) => void,
] {
  const [lang, setLangState] = useState<PhilippinesV2Lang>(
    getStoredPhilippinesV2Lang,
  );

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next: PhilippinesV2Lang) => {
    setLangState(next);
  }, []);

  return [lang, setLang];
}
